const MOBILE_VISIBLE_PLAYLIST_ITEMS = 5;
const HIDDEN_CLASS = "d-none";
const VISIBLE_CLASS = "d-xl-grid";
const TOGGLE_BUTTON_SELECTOR = '[data-show-hide-target="button"]';

function isPlaylistExpanded(slider: HTMLElement) {
  const toggleButton = slider.querySelector<HTMLElement>(
    TOGGLE_BUTTON_SELECTOR
  );

  if (toggleButton) {
    return toggleButton.getAttribute("aria-expanded") === "true";
  }

  return slider.getAttribute("data-show-hide-open-value") === "true";
}

function updateCollapsedMobileWindow(
  slider: HTMLElement,
  activeItem: HTMLElement,
  items: HTMLElement[]
) {
  if (isPlaylistExpanded(slider)) return;

  const activeIndex = items.indexOf(activeItem);

  if (activeIndex < 0) return;

  const maxStartIndex = Math.max(
    items.length - MOBILE_VISIBLE_PLAYLIST_ITEMS,
    0
  );
  const startIndex = Math.min(activeIndex, maxStartIndex);
  const endIndex = Math.min(
    startIndex + MOBILE_VISIBLE_PLAYLIST_ITEMS - 1,
    items.length - 1
  );

  items.forEach((item, index) => {
    const shouldShow = index >= startIndex && index <= endIndex;
    item.classList.toggle(HIDDEN_CLASS, !shouldShow);
    item.classList.toggle(VISIBLE_CLASS, !shouldShow);
  });
}

export { updateCollapsedMobileWindow };
